import {
  GET_CONTACTS_BREAKDOWN_REQUEST,
  GET_CONTACTS_BREAKDOWN_SUCCESS,
  GET_CONTACTS_BREAKDOWN_FAILURE,
  statusType
} from '../../actions'

const initial = {
  data: {},
  status: statusType.IDLE
}

const breakdown = (state = initial, action) => {
  const { payload } = action

  switch (action.type) {
    case GET_CONTACTS_BREAKDOWN_REQUEST:
      return {
        ...initial,
        status: statusType.IN_PROGRESS
      }

    case GET_CONTACTS_BREAKDOWN_SUCCESS:
      return {
        data: payload,
        status: statusType.SUCCESS
      }

    case GET_CONTACTS_BREAKDOWN_FAILURE:
      return {
        ...state,
        status: statusType.ERROR
      }

    default:
      return state
  }
}

export default breakdown
